import { useEffect, useState } from 'react';
import { CSVLink } from 'react-csv';
import { Box, Typography } from '@mui/material';
import moment from 'moment';

import { FORTA_BLUE, FORTA_WHITE } from '../../../utils/colors';
import DownloadIcon from '../../svgs/DownloanIcon';

const csvColumns = [
  'timesheet_id',
  'bt_name',
  'client_name',
  'clock_in_date',
  'clock_in_time',
  'clock_out_date',
  'clock_out_time',
  'service',
  'pay_period',
  'label',
  'hours',
];

export const CustomCsvDownloader = (tableData: any) => {
  const [csvData, setCsvData] = useState<any>([csvColumns]);
  const [csvFileName, setCSVFileName] = useState<string>('timesheet.csv');
  useEffect(() => {
    if (!tableData?.data?.displayData) return;
    let payPeriod = '';
    const values = tableData.data.displayData.map(({ data }: any) => {
      const [
        id,
        provider_name,
        client_name,
        service_code,
        _date,
        date_start,
        date_end,
        _duration,
        label,
        _client_id,
        _service_code_id,
        _utc_offset,
        _read_only,
        pay_period,
      ] = data;
      if (!payPeriod) {
        payPeriod = pay_period;
      }
      return [
        id,
        provider_name,
        client_name,
        moment(date_start).format('MM/DD/YYYY'), //clock-in date in MM/DD/YYYY format
        moment(date_start).format('hh:mm A Z'), //clock-in time with user timezone
        moment(date_end).format('MM/DD/YYYY'), //clock-out date in MM/DD/YYYY format
        moment(date_end).format('hh:mm A Z'), //clock-out time with user timezone
        service_code,
        pay_period,
        label?.replace(/"/g, '""'),
        moment.utc(moment(date_end).diff(moment(date_start))).format('HH:mm'), //hours time between clock-in and clock-out
      ];
    });
    setCsvData([csvColumns, ...values]);
    setCSVFileName(`timesheets(${payPeriod}).csv`);
  }, [tableData]);

  return (
    <CSVLink
      data={csvData}
      filename={csvFileName}
      style={{
        backgroundColor: FORTA_BLUE.primary,
        height: 40,
        width: 200,
        marginTop: 16,
        padding: '1em',
        color: FORTA_WHITE,
        borderRadius: '10px',
        display: 'flex',
        alignItems: 'center',
        textTransform: 'capitalize',
        fontWeight: 'bold',
        boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center' }} data-testid="csvDownloadButton">
        <DownloadIcon />
        <Typography ml={1}>DOWNLOAD CSV</Typography>
      </Box>
    </CSVLink>
  );
};
